
export default {
    name: 'ListRegiContentStatus',
    props: {
        newsItems: Array,
        detailPath: {
            type: String,
            default: 'Notice',
        },
        newsType: String,
    },
    data() {
        return {
            contents: [],
        }
    },

    methods: {
        onClickShowDetail(id) {
            const params = {
                id,
                newsType: this.newsType,
            }

            this.$emit('detailParams', params)
        },
    },
}
